import { createSelector } from "reselect";
import { TIMEZONE } from "../consts";
import { deepGet } from "../../../utils";

const configSelector = state => state.config;
const bookingSelector = state => state.booking;
const appointmentSelector = state => state.appointment;
const dataSourceSelector = state => state.dataSource;

const getState = (config, booking, appointment, dataSource) => {
  const options = dataSource.timeZones;
  const required = options.length !== 1;
  const value = required
    ? deepGet(appointment, [TIMEZONE])
    : options[0].timezoneUID;

  let text = "";
  if (value !== "") {
    const timezone = dataSource.timeZones.find(tz => tz.timezoneUID === value);
    if (timezone) {
      text = timezone.description;
    }
  }
  return {
    text,
    value,
    options,
    required,
    isOpen: booking.controlVisibility[TIMEZONE],
    hintText: config.timezoneHintText,
    completed: booking.completedSteps.includes(TIMEZONE),
    reload: booking.reload
  };
};

const timeZoneSelector = createSelector(
  configSelector,
  bookingSelector,
  appointmentSelector,
  dataSourceSelector,
  getState
);

export { timeZoneSelector };



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/selectors/timeZoneSelector.js